var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38 15.862 15.861 1.38a1.95 1.95 0 1 1 2.759 2.759L4.138 18.62a1.95 1.95 0 1 1-2.759-2.759Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.138 1.38 18.62 15.861a1.95 1.95 0 1 1-2.759 2.759L1.38 4.138a1.95 1.95 0 1 1 2.759-2.759Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7beeb6d5.svg";
export { ForwardRef as ReactComponent };